<!-- Learning Title -->
<dgx-profile-heading-v2
  *ngIf="!isPageLoading"
  [heading]="'dgProfileOverview_LearningTitle' | translate"
  [hasItems]="!!learnings.length"
  [viewAllUrl]="viewAllUrl"
  [viewAllUrlQueryParams]="viewAllUrlQueryParams"
  [showViewAll]="showViewAll"
  [ownerIsViewing]="ownerIsViewing"
>
  <dgx-add-menu-v2
    *ngIf="ownerIsViewing && showAdd"
    [menuConfig]="menuConfig"
  ></dgx-add-menu-v2>
</dgx-profile-heading-v2>

<dgx-profile-card-carousel-v2
  [emptyTileCount]="emptyTiles"
  *ngIf="!isEmpty && useCarousel && !isPageLoading"
>
  <ng-container
    *ngFor="
      let learning of learnings;
      trackBy: trackByCollectionId;
      let last = last;
      index as learningIndex
    "
    data-dgat="profile-learning-789"
  >
    <dgx-tile-launcher
      class="tile__wrapper l_flex m-l_flex l_flex-column learnings-tile"
      [ngClass]="{
        'guts-m-r-3': !last || learnings.length < learningDisplayLimit,
        'guts-m-r-half': learnings.length === learningDisplayLimit
      }"
      [tileIndex]="learningIndex"
      [expandCard]="(indexesOfExpandedCards$ | async)?.includes(learningIndex)"
      [item]="learning"
      [actionContext]="learning"
      [modifyOptionsFn]="modifyOptionsFn"
      [hideCommentField]="true"
      [useBorderedButtons]="false"
    ></dgx-tile-launcher>
  </ng-container>
</dgx-profile-card-carousel-v2>

<div *ngIf="!isEmpty && !useCarousel && !isPageLoading">
  <div class="grid" style="margin-top: -1.5rem">
    <div
      class="grid__col-12 grid__col--bleed"
      [style.overflow]="isMobile ? 'scroll' : 'unset'"
    >
      <ul
        class="grid grid--justify-space-between m-guts-p-l-half"
        [style.flexWrap]="isMobile ? 'nowrap' : 'wrap'"
      >
        <li
          *ngFor="
            let learning of learnings;
            trackBy: trackByCollectionId;
            let last = last;
            index as learningIndex
          "
          class="guts-p-l-0 grid__col-xs-6 auto-width m-guts-m-r-1"
          data-dgat="profile-learning-5ce"
          [class.guts-p-r-0]="
            !isMobile && (learningIndex + 1) % cardRowLimit === 0
          "
        >
          <span
            *ngIf="!useShowMore"
            dgxIntersectionObserver
            (onIntersection)="loadMoreLearnings(learningIndex)"
            [options]="{ threshold: 0.5 }"
            [unObserve]="false"
            role="presentation"
          ></span>
          <dgx-tile-launcher
            class="tile__wrapper l_flex m-l_flex l_flex-column learnings-tile"
            [ngClass]="{
              'guts-m-r-3':
                (!last || learnings.length < learningDisplayLimit) &&
                useCarousel,
              'guts-m-r-half': learnings.length === learningDisplayLimit
            }"
            [tileIndex]="learningIndex"
            [expandCard]="
              (indexesOfExpandedCards$ | async)?.includes(learningIndex)
            "
            [item]="learning"
            [actionContext]="learning"
            [modifyOptionsFn]="modifyOptionsFn"
            [hideCommentField]="true"
            [useBorderedButtons]="false"
          ></dgx-tile-launcher>
        </li>
        <li
          *ngFor="let count of emptyTiles; let last = last"
          class="empty-learnings-tile guts-m-v-1-half guts-m-r-1-half"
          [class.guts-m-r-0]="last"
          data-dgat="profile-learning-112"
        ></li>
      </ul>
      <div *ngIf="sectionLoading" class="l_flex">
        <dgx-skeleton
          type="userOutcome"
          class="grid__col-md-3 guts-p-l-0 m-guts-p-full-0"
        ></dgx-skeleton>
        <dgx-skeleton
          type="userOutcome"
          class="grid__col-md-3 no-mobile"
        ></dgx-skeleton>
        <dgx-skeleton
          type="userOutcome"
          class="grid__col-md-3 no-mobile guts-p-r-0"
        ></dgx-skeleton>
        <dgx-skeleton
          type="userOutcome"
          class="grid__col-md-3 no-mobile guts-p-r-0"
        ></dgx-skeleton>
      </div>
      <div *ngIf="useShowMore && hasMoreItems" class="center-text no-mobile">
        <button
          df-button
          dfButtonType="passive"
          class="btn btn-passive show-more-btn"
          (click)="loadMoreLearnings(currentEndIndex)"
          data-dgat="profile-learning-884"
        >
          <df-spinner-button [isSpinning]="sectionLoading">
            {{ 'Core_ShowMore' | translate }}
          </df-spinner-button>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Empty State -->
<dgx-profile-section-empty-state-v2
  *ngIf="isEmpty && !isPageLoading"
  [ownerIsViewing]="ownerIsViewing && showAdd"
>
  <dgx-add-menu-v2
    *ngIf="ownerIsViewing"
    [menuConfig]="menuConfig"
    [linkText]="i18n.dgProfileOverview_AddLearning"
  ></dgx-add-menu-v2>
</dgx-profile-section-empty-state-v2>

<div *ngIf="isPageLoading && useLoadingTemplate">
  <div class="guts-p-t-1-half">
    <dgx-skeleton type="mediumTitle"></dgx-skeleton>
    <div class="l_flex">
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 guts-p-l-0 m-guts-p-v-1-half m-guts-p-r-0"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile guts-p-r-0"
      ></dgx-skeleton>
    </div>
  </div>
</div>
